module.exports = __webpack_public_path__ + "static/media/galerija_2017 (19).c5b9a48b.jpg";